import React, { Suspense } from 'react'
import Progress from './Progress'

const Loadable = (Component: any) => (props: any) => (
    <Suspense fallback={<Progress/>}>
        <Component {...props}/>
    </Suspense>
)

export default Loadable